<template>
  <adminTable
    ref="adminTableRef"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:form-inline-items>
      <el-form-item>
        <el-input v-model="searchForm.phone" placeholder="请输入手机号" clearable />
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.status" placeholder="状态" clearable>
          <el-option v-for="item in statusOptions" :label="item.label" :value="item.value" :key="item.label" />
        </el-select>
      </el-form-item>
    </template>
    <!-- <template v-slot:query-button-right>
      <el-button type="primary" icon="CirclePlus" @click="editItem('add', {})" v-permission>添加</el-button>
    </template> -->
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="username" label="用户名" width="120" />
      <el-table-column prop="phone" label="用户手机号" width="160" />
      <el-table-column prop="coupon_name" label="优惠券名称" width="200" />
      <el-table-column prop="coupon_type_text" label="优惠券类型" width="120" />
      <el-table-column prop="type" label="状态" width="120">
        <template #default="scope">
          <span>{{ getLabelByVal(scope.row.status, statusOptions) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coupon_amount" label="优惠值" width="120">
        <template #default="scope">{{ scope.row.coupon_amount }} <span v-if="scope.row.coupon_type == 2">%</span> </template>
      </el-table-column>
      <el-table-column prop="create_at" label="添加时间" width="160" />
      <!-- <el-table-column label="操作" width="100" fixed="right">
        <template #default="scope">
          <el-button type="primary" icon="Edit" v-permission @click="editItem('edit', scope.row)">编辑</el-button>
          <el-button type="danger" icon="Delete" v-permission @click="deleteAction(scope.row)">删除</el-button>
        </template>
      </el-table-column> -->
    </template>
  </adminTable>
</template>

<script setup>
  import { ref, getCurrentInstance, onMounted } from 'vue'
  import { getLabelByVal } from '@/config/enums'
  import { useRoute } from 'vue-router'
  import couponEnumHook from '@/hooks/couponEnumHook'

  const route = useRoute()

  const { openStatus, typeOptions, statusOptions } = couponEnumHook()

  const currentUser = JSON.parse(sessionStorage.getItem('currentUser'))
  const searchForm = ref({
    name: '',
    type: '',
  })
  const adminTableRef = ref(null)

  onMounted(() => {
    if (route.query && route.query.phone) {
      searchForm.value.phone = route.query.phone
    }
    getList()
  })

  const { proxy } = getCurrentInstance()

  const tableData = ref([])
  const page = ref(1)
  const limit = ref(10)
  const totalList = ref(0)
  const tableLoading = ref(false)

  const getList = async () => {
    tableLoading.value = true
    const res = await proxy.$http({
      type: 'get',
      url: '/userCoupon/lists',
      params: {
        ...searchForm.value,
        page: page.value,
        limit: limit.value,
      },
    })
    tableLoading.value = false
    if (res.code == 0) {
      tableData.value = res.data.data
      totalList.value = res.data.total
    }
  }
</script>

<style lang="less" scoped></style>
